export default function fetchNewTermo(body) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/termos', {
        method: 'POST',
        body,
    });
}